import { useEffect, useRef } from "react";

type Props = {
  id: string;
  value: string;
  isDisabled?: boolean;
  type?: string;
};

export default function useScriptFunction({
  id,
  value,
  isDisabled = false,
  type,
}: Props) {
  const createdByHookRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const removeIfOwned = () => {
      if (createdByHookRef.current) {
        document.getElementById(id)?.remove();
        createdByHookRef.current = false;
      }
    };

    if (isDisabled) {
      removeIfOwned();

      return;
    }

    if (document.getElementById(id)) return;

    const script = document.createElement("script");

    if (type) {
      script.type = type;
    }
    script.innerHTML = value;
    script.id = id;

    document.head.appendChild(script);
    createdByHookRef.current = true;

    return removeIfOwned;
  }, [id, value, isDisabled, type]);
}
